import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlideTallAdd: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="slide-tall-add"><path d="M4.75 2.75V21.25H19.25V2.75H4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 12H12M12 12H15.25M12 12V15.25M12 12V8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSlideTallAdd;
